import * as React from "react";
import "../../style/fonts.css";
import "./retrievePass.css";
import CtaButton from "../ctaButton/ctaButton";
import Input from "../input/input";
import {
  resetPass,
  resetPassWarningReset,
  resetPassErrorReset
} from "src/store/actions/authActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import translate from "../../translations/i18n";

export interface Props {
  resetPass(email): void;
  authError: any;
  emailSent: any;
  emailWarningReset: string;
  resetPassErrorReset: () => void;
  resetPassWarningReset: () => void;
}

interface State {
  email: string;
  submitted?: boolean;
}

class RetrievePassScr extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { email: "" };
    this.resetPassword = this.resetPassword.bind(this);
  }

  componentDidMount() {
    this.props.resetPassErrorReset();
    this.props.resetPassWarningReset();
  }

  handleChangeMail(event) {
    this.setState({ email: event.target.value });
    this.props.resetPassWarningReset();
    this.props.resetPassErrorReset();
    this.setState({ submitted: false });
  }

  resetPassword() {
    console.warn(this.state.email);
    
    this.setState({ submitted: true });
    this.props.resetPass(this.state.email);
  }

  render() {
    if (this.props.emailSent === true && this.state.submitted) {
      return (
        <Redirect
          to={{
            pathname: "/checkEmails",
            state: { mailAddress: this.state.email }
          }}
          push
        />
      );
    } else {
      return (
        <div className="RETRIEVE_CONT">
          <div className="RETRIEVE_TITLE">
            <div className="TITLE_2">{translate("RETRIVE_PASSWORD_TITLE")}</div>
          </div>
          <div className="RETRIEVE_TEXT">
            <div className="REG_TEXT">{translate("RETRIVE_PASSWORD_TEXT")}</div>
          </div>
          <div className="RETRIEVEPASS_EMAIL_CONT">
            <Input
              type={"text"}
              placeholder={translate("EMAIL_FORM")}
              value={this.state.email}
              onChange={this.handleChangeMail.bind(this)}
              warning={
                this.props.emailWarningReset &&
                translate(this.props.emailWarningReset)
              }
              passwordSeen={null}
            />
          </div>
          <div
            className="RETRIEVEPASS_BTN_AREA"
            onClick={this.resetPassword.bind(this)}
          >
            <CtaButton
              width={"280px"}
              text={translate("CTA_SEND_NEW_PASSWORD")}
              color={"white"}
            />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    authError: state.auth.authError,
    emailSent: state.auth.emailSentReset,
    emailWarningReset: state.auth.emailWarningReset
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetPass: email => dispatch(resetPass(email)),
    resetPassErrorReset: () => dispatch(resetPassErrorReset()),
    resetPassWarningReset: () => dispatch(resetPassWarningReset())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RetrievePassScr);



// WEBPACK FOOTER //
// ./src/components/Registration/retrievePass.tsx